import React, { useMemo } from "react";
import { Carousel, Row, Col, Image, Card, Typography, Grid } from "antd";

const { Title } = Typography;
const { useBreakpoint } = Grid;

const chunkArray = (arr, size) =>
  arr.reduce((acc, _, i) => {
    if (i % size === 0) acc.push(arr.slice(i, i + size));
    return acc;
  }, []);

export default function Gallery() {
  const screens = useBreakpoint();

  const itemsPerSlide = screens.xl ? 6 : screens.lg ? 6 : screens.md ? 4 : 1;
const colSpan =
  itemsPerSlide === 6 ? 4 : itemsPerSlide === 4 ? 6 : 24;


  // ✅ Build exact filenames from your folder (case-sensitive safe)
  const images = useMemo(() => {
    const list = [];

    // 00.jpg
    list.push("/Assets4/5.jpg");

    // 1.jpg to 44.jpg
    for (let i = 6; i <= 44; i++) list.push(`/Assets4/${i}.jpg`);

    // 45.JPG to 49.JPG  (uppercase extension)
    for (let i = 45; i <= 49; i++) list.push(`/Assets4/${i}.JPG`);

    // 50.jpg to 51.jpg
    for (let i = 50; i <= 51; i++) list.push(`/Assets4/${i}.jpg`);

    return list;
  }, []);

  const slides = useMemo(
    () => chunkArray(images, itemsPerSlide),
    [images, itemsPerSlide]
  );

  const titleFontSize =
    screens.xl ? "48px" : screens.lg ? "48px" : screens.md ? "46px" : "36px";

  return (
    <Card style={{ backgroundColor: "#0D102D", borderColor: "#0D102D", borderRadius: 12 }}>
      <Title
        style={{
          textAlign: "center",
          padding: "20px 40px",
          fontWeight: 700,
          fontSize: titleFontSize,
          color: "white",
          marginBottom: 10,
        }}
      >
        Gallery
      </Title>

      <Carousel autoplay infinite dots>
        {slides.map((group, index) => (
          <div key={index}>
            <div style={{ padding: "0 40px 30px" }}>
              <Row gutter={[16, 16]} justify="center">
                {group.map((src, idx) => (
                  <Col span={colSpan} key={idx}>
                    <Image
                      src={src}
                      preview
                      fallback="/Assets4/00.jpg"
                      style={{
                        width: "100%",
                        height: 200,
                        objectFit: "cover",
                        borderRadius: 12,
                      }}
                    />
                  </Col>
                ))}
              </Row>
            </div>
          </div>
        ))}
      </Carousel>
    </Card>
  );
}
